import React, { useState, useEffect } from 'react';
import {
  Row, Col, Tab,
} from 'react-bootstrap5';
import axios from 'axios';

import routes from 'app/routes';
import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';

import Pagination from './Pagination';
import SessionToScheduleItem from './SessionToScheduleItem';

export default function SessionsToSchedule({ refresh }) {
  const [rawSteps, setRawSteps] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.members.schedule.sessionsToSchedule)
      .then((resp) => {
        setRawSteps(resp.data.data);
      });
  }, []);

  if (rawSteps === null) {
    return (
      <LoadingPlaceholder text="Loading..." className="py-5" />
    );
  }

  const stepsOnPage = 10;
  const groupedSteps = Object.groupBy(rawSteps, (_step, index) => parseInt(index / stepsOnPage, 10));
  const eventKey = (page) => `sessions-to-schedule-page-${page}`;

  return (
    <>
      {rawSteps.length === 0 ? (
        <p className="py-3 py-sm-5 text-center">
          You have no sessions to schedule.
        </p>
      ) : (
        <Tab.Container
          id="sessions-to-schedule"
          defaultActiveKey={eventKey(0)}
        >
          <Tab.Content className="mt-4">
            {Object.keys(groupedSteps).map((page) => (
              <Tab.Pane key={eventKey(page)} eventKey={eventKey(page)}>
                <Row>
                  {groupedSteps[page].map((step) => (
                    <Col key={step.id} lg={6} className="mb-4">
                      <SessionToScheduleItem step={step} refresh={refresh} />
                    </Col>
                  ))}
                </Row>
              </Tab.Pane>
            ))}
          </Tab.Content>

          <Pagination
            steps={rawSteps}
            pageSize={stepsOnPage}
            eventKey={eventKey}
          />
        </Tab.Container>
      )}
    </>
  );
}
